import React, { useEffect } from "react";
import { APIEndpoint, EndpointType } from "../utils/apiService";

interface Props {
    params: { [key: string]: string }
    submit: boolean
    onFormSubmitted: () => void
}

const apiURL = APIEndpoint(EndpointType.Hubspot);

const HubspotUTMForm = (props: Props) => {
    useEffect(() => {
        if (props.submit) {
            // Submit the form
            const form = document.querySelector("form");
            if (form) {
                form.submit();
                props.onFormSubmitted();
            }
        }
    }, [props.submit]);

    return (
        <div>
            <form method="POST" action={apiURL} target="dummyframe" style={{ display: "none" }}>
                {Object.keys(props.params).map(name => (
                    <input
                        key={name}
                        type="hidden"
                        name={name}
                        value={props.params[name]}
                    />
                ))}
            </form>
            <iframe name="dummyframe" id="dummyframe" style={{ display: "none" }}></iframe>
        </div>
    );

}

export default HubspotUTMForm;